// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor_list_screen_layout-layout .container-actions {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 10px;\n  margin: 15px 0px;\n  justify-content: flex-end; }\n\n.editor_list_screen_layout-layout .editor-list-items {\n  display: flex;\n  flex-direction: column;\n  gap: 10px; }\n", ""]);
// Exports
module.exports = exports;
